import * as swcHelpers from '@swc/helpers';
import { useMemo } from 'react';
import { useDebouncedEffect } from '@grandvisionhq/utils';
import { useAlgoliaConfig } from '../AlgoliaConfig.js';
import { searchStateToQueryObject, getNonQueryObject } from '../utils/query-string.js';

const useQueryChange = (NextRouter, searchState, clientQueryString)=>{
    const { facets , sortIndices , pageSize , presetQueryObject  } = useAlgoliaConfig();
    const { queryObject , nonQueryObject  } = useMemo(()=>({
            queryObject: searchStateToQueryObject(searchState, {
                facets,
                sortIndices,
                pageSize,
                presetQueryObject
            }),
            nonQueryObject: getNonQueryObject(clientQueryString, {
                facets
            })
        })
    , // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        searchState,
        JSON.stringify(facets),
        sortIndices,
        pageSize
    ]);
    const query = useMemo(()=>swcHelpers.objectSpread({}, queryObject, nonQueryObject)
    , // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        JSON.stringify(queryObject),
        JSON.stringify(nonQueryObject)
    ]);
    useDebouncedEffect(()=>{
        const [pathWithoutHash, hash] = (NextRouter.asPath || '').split('#');
        const pathname = pathWithoutHash === null || pathWithoutHash === void 0 ? void 0 : pathWithoutHash.split('?')[0];
        NextRouter.replace({
            pathname: NextRouter.pathname,
            query
        }, {
            pathname,
            query,
            hash
        }, {
            shallow: true
        });
    }, 500, [
        query
    ]);
};
function UseQueryChange({ NextRouter , searchState , clientQueryString  }) {
    useQueryChange(NextRouter, searchState, clientQueryString);
    return null;
}

export { UseQueryChange, useQueryChange };
//# sourceMappingURL=use-query-change.js.map
